{
  "version": 1,
  "asset_id": "2e9f974a-870e-4baa-9f89-089026fe1a0f",
  "project_id": "a3729fa2-e85b-4f5b-84b2-0934e880c580",
  "url": "/__l5e/assets-v1/2e9f974a-870e-4baa-9f89-089026fe1a0f/palworld-keychain-cattiva.webp",
  "r2_key": "a/v1/a3729fa2-e85b-4f5b-84b2-0934e880c580/2e9f974a-870e-4baa-9f89-089026fe1a0f/palworld-keychain-cattiva.webp",
  "original_filename": "palworld-keychain-cattiva.webp",
  "size": 29656,
  "content_type": "image/webp",
  "created_at": "2026-09-01T00:36:08Z"
}
